
namespace GeniuzPOS.RefundReasonReport {

    @Serenity.Decorators.registerClass()
    export class ReportRefundReasonByItemGrid extends Serenity.EntityGrid<ReportRefundReasonByItemRow, any> {
        protected getColumnsKey() { return ReportRefundReasonByItemColumns.columnsKey; }
        protected getDialogType() { return ReportRefundReasonByItemDialog; }
        protected getIdProperty() { return ReportRefundReasonByItemRow.idProperty; }
        protected getInsertPermission() { return ReportRefundReasonByItemRow.insertPermission; }
        protected getLocalTextPrefix() { return ReportRefundReasonByItemRow.localTextPrefix; }
        protected getService() { return ReportRefundReasonByItemService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();

             buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'refresh-button'), 1)
            //  buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
             buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
             //buttons.push(send);


             // Add buttons import excel, pdf
             buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                 grid: this,
                 service: ReportRefundReasonByItemService.baseUrl + '/ListExcel',
                 onViewSubmit: () => this.onViewSubmit(),
                 separator: true
             }));

             buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRywcSpec#QRreport.QRyReportRefundReasonByItem/edit/130';
                        return false;
                    },
                }
            );


            return buttons;
        }
    }
}